import { IEstimatorOption } from './types';

export const PROJECT_TYPE_OPTIONS: IEstimatorOption[] = [
  {
    description:
      'Customer-facing mobile experience with backend workflows and operational tooling.',
    label: 'Mobile application',
    value: 'mobile-app',
  },
  {
    description:
      'E-commerce storefront, checkout flows, catalog structure, and operational commerce tooling.',
    label: 'Webshop / e-commerce platform',
    value: 'webshop',
  },
  {
    description:
      'Custom workflows, automation, and business logic for commercial or service teams.',
    label: 'Custom CRM system',
    value: 'custom-crm',
  },
  {
    description:
      'Operational process orchestration, approvals, dashboards, and back-office workflows.',
    label: 'ERP / operations workflow platform',
    value: 'erp-workflow',
  },
  {
    description: 'Internal platform for employees, field teams, or multi-step process execution.',
    label: 'Internal operational platform',
    value: 'internal-platform',
  },
  {
    description: 'Partner portals, client platforms, multi-role products, or custom B2B software.',
    label: 'Complex B2B system',
    value: 'b2b-system',
  },
  {
    description: 'API-first platform, integrations layer, or backend modernization initiative.',
    label: 'Backend / API platform',
    value: 'backend-platform',
  },
];

export const USER_ROLE_OPTIONS: IEstimatorOption[] = [
  { label: '1 role', value: '1' },
  { label: '2-3 roles', value: '2-3' },
  { label: '4-6 roles', value: '4-6' },
  { label: '7+ roles', value: '7-plus' },
];

export const USER_COUNT_OPTIONS: IEstimatorOption[] = [
  { label: 'Under 100 users', value: 'under-100' },
  { label: '100-1,000 users', value: '100-1000' },
  { label: '1,000-10,000 users', value: '1000-10000' },
  { label: '10,000+ users', value: '10000-plus' },
];

export const TIMELINE_OPTIONS: IEstimatorOption[] = [
  { label: 'Discovery first, timeline flexible', value: 'flexible' },
  { label: 'Launch in 3 months', value: '3-months' },
  { label: 'Launch in 4-6 months', value: '4-6-months' },
  { label: 'Launch in 6-9 months', value: '6-9-months' },
  { label: 'Longer roadmap / phased delivery', value: '9-plus-months' },
];

export const BUDGET_OPTIONS: IEstimatorOption[] = [
  { label: 'Under €20,000', value: 'under-20k' },
  { label: '€20,000 - €40,000', value: '20k-40k' },
  { label: '€40,000 - €75,000', value: '40k-75k' },
  { label: '€75,000 - €150,000', value: '75k-150k' },
  { label: '€150,000+', value: '150k-plus' },
];

export const API_ENDPOINT_COUNT_OPTIONS: IEstimatorOption[] = [
  { label: 'Up to 10 endpoints', value: 'api-endpoints-under-10' },
  { label: '11-25 endpoints', value: 'api-endpoints-10-25' },
  { label: '26-60 endpoints', value: 'api-endpoints-25-60' },
  { label: '60+ endpoints', value: 'api-endpoints-60-plus' },
];

export const WEBHOOK_FLOW_COUNT_OPTIONS: IEstimatorOption[] = [
  { label: '1-5 webhook flows', value: 'webhook-flows-1-5' },
  { label: '6-15 webhook flows', value: 'webhook-flows-6-15' },
  { label: '16-40 webhook flows', value: 'webhook-flows-16-40' },
  { label: '40+ webhook flows', value: 'webhook-flows-40-plus' },
];

export const QUEUE_WORKFLOW_COUNT_OPTIONS: IEstimatorOption[] = [
  { label: '1-3 queue or job workflows', value: 'queue-flows-1-3' },
  { label: '4-10 queue or job workflows', value: 'queue-flows-4-10' },
  { label: '11-25 queue or job workflows', value: 'queue-flows-11-25' },
  { label: '25+ queue or job workflows', value: 'queue-flows-25-plus' },
];

export const MIGRATION_OPTIONS: IEstimatorOption[] = [
  { label: 'No migration needed', value: 'none' },
  { label: 'Partial migration from current tools', value: 'partial' },
  { label: 'Full migration from existing system', value: 'full' },
];

export const IMPLEMENTATION_PATH_PREFERENCE_OPTIONS: IEstimatorOption[] = [
  {
    label: 'WooCommerce',
    value: 'commerce-path-woocommerce',
  },
  {
    label: 'Shopify',
    value: 'commerce-path-shopify',
  },
  {
    label: 'Custom',
    value: 'commerce-path-fully-custom',
  },
  {
    label: 'Not sure yet',
    value: 'commerce-path-not-sure',
  },
];

export const ADMIN_EXPERIENCE_PREFERENCE_OPTIONS: IEstimatorOption[] = [
  { label: 'Yes, a familiar admin is important', value: 'admin-familiar-important' },
  { label: 'Nice to have, but not essential', value: 'admin-familiar-nice' },
  { label: 'No, a custom back-office is acceptable', value: 'admin-custom-acceptable' },
];

export const COMMERCE_LOGIC_COMPLEXITY_OPTIONS: IEstimatorOption[] = [
  { label: 'Mostly standard webshop flows', value: 'commerce-logic-standard' },
  {
    label: 'Some custom pricing, fulfillment, or account logic',
    value: 'commerce-logic-moderate',
  },
  { label: 'Highly custom business rules and workflows', value: 'commerce-logic-high' },
];

export const PRODUCT_MODEL_OPTIONS: IEstimatorOption[] = [
  { label: 'Physical products', value: 'commerce-physical-products' },
  { label: 'Digital products', value: 'commerce-digital-products' },
  { label: 'Subscriptions / recurring billing', value: 'commerce-subscriptions' },
  { label: 'Services / bookings', value: 'commerce-services-booking' },
  { label: 'Marketplace / multi-vendor', value: 'commerce-marketplace' },
];

export const CATALOG_SIZE_OPTIONS: IEstimatorOption[] = [
  { label: 'Under 50 products', value: 'catalog-size-under-50' },
  { label: '50-500 products', value: 'catalog-size-50-500' },
  { label: '500-5,000 products', value: 'catalog-size-500-5000' },
  { label: '5,000+ products', value: 'catalog-size-5000-plus' },
];

export const CATALOG_COMPLEXITY_OPTIONS: IEstimatorOption[] = [
  { label: 'Simple catalog structure', value: 'catalog-simple-taxonomy' },
  { label: 'Filters, variants, and attributes', value: 'catalog-attribute-rich' },
  { label: 'Multi-brand / complex taxonomy', value: 'catalog-multi-brand' },
];

export const CHECKOUT_COMPLEXITY_OPTIONS: IEstimatorOption[] = [
  { label: 'Standard checkout', value: 'checkout-standard' },
  { label: 'Discounts, coupons, or bundles', value: 'checkout-promos' },
  { label: 'Multi-market shipping / tax logic', value: 'checkout-multi-market' },
  { label: 'B2B pricing, quotes, or account rules', value: 'checkout-b2b' },
];

export const INVENTORY_COMPLEXITY_OPTIONS: IEstimatorOption[] = [
  { label: 'No stock sync or very basic stock', value: 'inventory-basic' },
  { label: 'Warehouse or ERP stock sync', value: 'inventory-warehouse-sync' },
  { label: 'Multi-location inventory', value: 'inventory-multi-location' },
  { label: 'Supplier / dropship fulfillment logic', value: 'inventory-supplier-sync' },
];

export const SURFACE_OPTIONS = [
  { label: 'Mobile application', value: 'mobile-app' },
  { label: 'Web platform', value: 'web-platform' },
  { label: 'Admin / back-office panel', value: 'admin-panel' },
  { label: 'Backend / API layer', value: 'backend-api' },
];

export const PROJECT_TYPE_SURFACE_MAP: Record<string, string[]> = {
  'backend-platform': ['backend-api'],
  'b2b-system': ['mobile-app', 'web-platform', 'admin-panel', 'backend-api'],
  'custom-crm': ['mobile-app', 'web-platform', 'admin-panel', 'backend-api'],
  'erp-workflow': ['mobile-app', 'web-platform', 'admin-panel', 'backend-api'],
  'internal-platform': ['mobile-app', 'web-platform', 'admin-panel', 'backend-api'],
  'mobile-app': ['mobile-app', 'admin-panel', 'backend-api'],
  webshop: ['mobile-app', 'web-platform', 'admin-panel', 'backend-api'],
};

export const DEFAULT_SURFACE_VALUES = ['mobile-app', 'web-platform', 'admin-panel', 'backend-api'];

export const AUTHENTICATION_OPTIONS = [
  { label: 'Email / password login', value: 'email-password' },
  { label: 'Social login', value: 'social-login' },
  { label: 'Single sign-on (SSO)', value: 'sso' },
  { label: 'Granular role permissions', value: 'rbac' },
  { label: 'Multi-factor authentication', value: 'mfa' },
];

export const CAPABILITY_OPTIONS = [
  { label: 'Payment integration', value: 'payments' },
  { label: 'Promotions / discount logic', value: 'promotions-discounts' },
  { label: 'Notifications', value: 'notifications' },
  { label: 'Chat / messaging', value: 'chat' },
  { label: 'Search and filtering', value: 'search-filtering' },
  { label: 'Scheduling / booking', value: 'scheduling-booking' },
  { label: 'Returns / refunds workflow', value: 'returns-refunds' },
  { label: 'Document generation', value: 'document-generation' },
  { label: 'Real-time dashboards', value: 'realtime-dashboards' },
  { label: 'Data import / export', value: 'data-import-export' },
  { label: 'Audit and activity history', value: 'audit-history' },
  { label: 'Maps and route planning', value: 'maps-route-planning' },
  { label: 'Task management / assignment', value: 'task-management' },
  { label: 'Calendar and resource planning', value: 'resource-planning' },
  { label: 'Customer / partner portal access', value: 'portal-access' },
  { label: 'AI features', value: 'ai-features' },
  { label: 'Multilingual support', value: 'multilingual' },
  { label: 'Offline mode / sync', value: 'offline-mode' },
  { label: 'Analytics / reporting', value: 'analytics' },
  { label: 'Media capture', value: 'media-capture' },
  { label: 'File upload / document handling', value: 'file-management' },
  { label: 'GPS / geolocation', value: 'geolocation' },
  { label: 'Webhook orchestration', value: 'webhook-orchestration' },
  { label: 'Background jobs / queue processing', value: 'background-jobs' },
];

export const INTEGRATION_OPTIONS = [
  { label: 'CRM systems', value: 'crm' },
  { label: 'ERP systems', value: 'erp' },
  { label: 'Accounting / invoicing', value: 'accounting' },
  { label: 'Maps / logistics APIs', value: 'maps' },
  { label: 'BI / reporting tools', value: 'bi' },
  { label: 'IoT / hardware devices', value: 'iot' },
  { label: 'Legacy systems', value: 'legacy' },
];

export const COMPLIANCE_OPTIONS = [
  { label: 'GDPR / privacy controls', value: 'gdpr' },
  { label: 'Audit logs / traceability', value: 'audit-logs' },
  { label: 'Enterprise security reviews', value: 'enterprise-security' },
  { label: 'Industry compliance requirements', value: 'industry-compliance' },
];

export const FEATURE_POINT_MAP: Record<string, number> = {
  'admin-panel': 15,
  'ai-features': 25,
  analytics: 10,
  'api-endpoints-10-25': 8,
  'api-endpoints-25-60': 14,
  'api-endpoints-60-plus': 22,
  'api-endpoints-under-10': 4,
  'audit-history': 8,
  'audit-logs': 8,
  'backend-api': 18,
  chat: 12,
  'custom-crm': 20,
  'data-import-export': 8,
  'document-generation': 8,
  'email-password': 4,
  'enterprise-security': 16,
  erp: 18,
  'erp-workflow': 22,
  'file-management': 8,
  geolocation: 12,
  gdpr: 6,
  'industry-compliance': 18,
  'inventory-basic': 4,
  'inventory-multi-location': 14,
  'inventory-supplier-sync': 18,
  'inventory-warehouse-sync': 10,
  'internal-platform': 18,
  iot: 20,
  legacy: 16,
  maps: 7,
  'maps-route-planning': 10,
  'media-capture': 8,
  mfa: 8,
  'mobile-app': 20,
  multilingual: 6,
  notifications: 8,
  'offline-mode': 18,
  partial: 10,
  payments: 8,
  'portal-access': 12,
  'promotions-discounts': 8,
  'background-jobs': 14,
  'queue-flows-1-3': 4,
  'queue-flows-11-25': 14,
  'queue-flows-25-plus': 20,
  'queue-flows-4-10': 8,
  rbac: 10,
  'realtime-dashboards': 12,
  'resource-planning': 12,
  'returns-refunds': 8,
  'scheduling-booking': 10,
  'search-filtering': 6,
  'social-login': 5,
  sso: 12,
  'task-management': 10,
  'webhook-orchestration': 12,
  'webhook-flows-1-5': 3,
  'webhook-flows-16-40': 12,
  'webhook-flows-40-plus': 18,
  'webhook-flows-6-15': 7,
  'catalog-attribute-rich': 8,
  'catalog-multi-brand': 12,
  'catalog-simple-taxonomy': 4,
  'catalog-size-50-500': 5,
  'catalog-size-500-5000': 10,
  'catalog-size-5000-plus': 16,
  'catalog-size-under-50': 2,
  'checkout-b2b': 20,
  'checkout-multi-market': 16,
  'checkout-promos': 10,
  'checkout-standard': 6,
  'commerce-digital-products': 5,
  'commerce-marketplace': 22,
  'commerce-physical-products': 6,
  'commerce-services-booking': 10,
  'commerce-subscriptions': 12,
  'commerce-logic-high': 18,
  'commerce-logic-moderate': 8,
  'commerce-logic-standard': 2,
  'web-platform': 15,
  'b2b-system': 28,
  'backend-platform': 20,
  webshop: 18,
  full: 18,
};

export const PROJECT_TYPE_CAPABILITY_MAP: Record<string, string[]> = {
  'backend-platform': [
    'search-filtering',
    'data-import-export',
    'document-generation',
    'audit-history',
    'analytics',
    'webhook-orchestration',
    'background-jobs',
    'ai-features',
    'file-management',
  ],
  'b2b-system': [
    'search-filtering',
    'portal-access',
    'document-generation',
    'realtime-dashboards',
    'data-import-export',
    'audit-history',
    'notifications',
    'analytics',
    'file-management',
    'ai-features',
    'multilingual',
  ],
  'custom-crm': [
    'search-filtering',
    'document-generation',
    'realtime-dashboards',
    'data-import-export',
    'audit-history',
    'notifications',
    'analytics',
    'file-management',
    'task-management',
    'resource-planning',
    'scheduling-booking',
    'ai-features',
  ],
  'erp-workflow': [
    'search-filtering',
    'document-generation',
    'realtime-dashboards',
    'data-import-export',
    'audit-history',
    'notifications',
    'analytics',
    'file-management',
    'maps-route-planning',
    'task-management',
    'resource-planning',
    'scheduling-booking',
    'ai-features',
  ],
  'internal-platform': [
    'search-filtering',
    'document-generation',
    'realtime-dashboards',
    'data-import-export',
    'audit-history',
    'notifications',
    'analytics',
    'file-management',
    'maps-route-planning',
    'task-management',
    'resource-planning',
    'scheduling-booking',
    'offline-mode',
    'ai-features',
  ],
  'mobile-app': [
    'notifications',
    'offline-mode',
    'maps-route-planning',
    'scheduling-booking',
    'payments',
    'chat',
    'analytics',
    'media-capture',
    'file-management',
    'multilingual',
    'ai-features',
    'geolocation',
  ],
  webshop: [
    'payments',
    'promotions-discounts',
    'search-filtering',
    'scheduling-booking',
    'returns-refunds',
    'document-generation',
    'notifications',
    'analytics',
    'file-management',
    'portal-access',
    'multilingual',
    'data-import-export',
    'ai-features',
  ],
};

export const WEBSHOP_BASE_CAPABILITY_VALUES = [
  'payments',
  'promotions-discounts',
  'search-filtering',
  'scheduling-booking',
  'returns-refunds',
  'document-generation',
  'notifications',
  'analytics',
  'file-management',
  'portal-access',
  'multilingual',
  'data-import-export',
  'ai-features',
];

export const WEBSHOP_MOBILE_CAPABILITY_VALUES = [
  'chat',
  'offline-mode',
  'geolocation',
  'maps-route-planning',
  'media-capture',
];

export const DEFAULT_CAPABILITY_VALUES = [
  'payments',
  'promotions-discounts',
  'notifications',
  'chat',
  'search-filtering',
  'scheduling-booking',
  'returns-refunds',
  'document-generation',
  'realtime-dashboards',
  'data-import-export',
  'audit-history',
  'maps-route-planning',
  'task-management',
  'resource-planning',
  'portal-access',
  'ai-features',
  'multilingual',
  'offline-mode',
  'analytics',
  'media-capture',
  'file-management',
  'geolocation',
  'webhook-orchestration',
  'background-jobs',
];

export const getAllowedCapabilityValues = (
  projectTypeValue?: string,
  selectedSurfaces: string[] = [],
) => {
  if (projectTypeValue === 'webshop') {
    const values = new Set(WEBSHOP_BASE_CAPABILITY_VALUES);

    if (selectedSurfaces.includes('mobile-app')) {
      WEBSHOP_MOBILE_CAPABILITY_VALUES.forEach(value => values.add(value));
    }

    return Array.from(values);
  }

  if (projectTypeValue) {
    return PROJECT_TYPE_CAPABILITY_MAP[projectTypeValue] || DEFAULT_CAPABILITY_VALUES;
  }

  return DEFAULT_CAPABILITY_VALUES;
};

export const EDUCATIONAL_COST_DRIVERS = [
  {
    key: 'offline-sync',
    title: 'Offline sync',
    description:
      'Offline support means conflict resolution, local storage, sync orchestration, and more complex QA. It is one of the most underestimated cost drivers in mobile and field operations products.',
  },
  {
    key: 'realtime',
    title: 'Real-time systems',
    description:
      'Chat, live dashboards, operational updates, and collaborative workflows introduce socket infrastructure, delivery guarantees, state management complexity, and heavier testing.',
  },
  {
    key: 'integrations',
    title: 'Integrations',
    description:
      'Every external system has its own API limitations, edge cases, authentication model, and change risk. Integrations often expand both implementation and long-term maintenance scope.',
  },
  {
    key: 'ai',
    title: 'AI features',
    description:
      'AI is rarely just a prompt box. Production AI usually needs structured inputs, evaluation loops, guardrails, observability, human fallback, and policy constraints.',
  },
  {
    key: 'scalability',
    title: 'Scalability',
    description:
      'Building for hundreds of users versus thousands changes architecture decisions around background jobs, caching, data modeling, monitoring, and infrastructure resilience.',
  },
  {
    key: 'enterprise-auth',
    title: 'Enterprise authentication',
    description:
      'SSO, MFA, auditability, access control, and permission hierarchies increase both implementation detail and security review effort.',
  },
  {
    key: 'compliance',
    title: 'Compliance',
    description:
      'Privacy, audit trails, retention rules, and industry-specific controls influence architecture, documentation, release process, and QA effort from the start.',
  },
  {
    key: 'analytics',
    title: 'Analytics and reporting',
    description:
      'Good reporting means event design, trusted data pipelines, role-specific dashboards, and decisions around what must be real-time versus periodic.',
  },
];

export const AI_FEATURE_CATALOG = [
  'mobile-app',
  'webshop',
  'web-platform',
  'admin-panel',
  'backend-api',
  'payments',
  'notifications',
  'chat',
  'search-filtering',
  'scheduling-booking',
  'document-generation',
  'realtime-dashboards',
  'data-import-export',
  'audit-history',
  'maps-route-planning',
  'portal-access',
  'ai-features',
  'multilingual',
  'offline-mode',
  'analytics',
  'file-management',
  'geolocation',
  'search-filtering',
  'scheduling-booking',
  'document-generation',
  'realtime-dashboards',
  'data-import-export',
  'audit-history',
  'maps-route-planning',
  'portal-access',
  'crm',
  'erp',
  'accounting',
  'maps',
  'bi',
  'iot',
  'legacy',
  'social-login',
  'sso',
  'rbac',
  'mfa',
  'gdpr',
  'audit-logs',
  'enterprise-security',
  'industry-compliance',
  'commerce-physical-products',
  'commerce-digital-products',
  'commerce-subscriptions',
  'commerce-services-booking',
  'commerce-marketplace',
  'commerce-logic-standard',
  'commerce-logic-moderate',
  'commerce-logic-high',
  'catalog-size-under-50',
  'catalog-size-50-500',
  'catalog-size-500-5000',
  'catalog-size-5000-plus',
  'catalog-simple-taxonomy',
  'catalog-attribute-rich',
  'catalog-multi-brand',
  'checkout-standard',
  'checkout-promos',
  'checkout-multi-market',
  'checkout-b2b',
  'inventory-basic',
  'inventory-warehouse-sync',
  'inventory-multi-location',
  'inventory-supplier-sync',
  'migration',
];
